import styled from 'styled-components'

export const SelectContainer = styled.div`
  width: 150px;
`
